/**
 * 基础路由
 * @type { *[] }
 */
export default [

]
